import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const HomeButton = () => {
  return (
    <a
      href={import.meta.env.VITE_GLOBAL_APP_URL}
      className={`mb-4 mr-4 block w-full rounded-md border border-gray-300 bg-gray-50 px-[18px] py-[10px] text-center text-lg font-semibold shadow md:inline-block md:w-fit`}
    >
      <FontAwesomeIcon icon={faArrowLeft} />
      &nbsp;Back to home
    </a>
  );
};

export { HomeButton };
